<template>
  <b-card v-if="data" no-body class="card-statistics">
    <b-card-header>
      <b-card-title>Utilisateurs</b-card-title>
    </b-card-header>

    <b-card-body class="statistics-body">
      <b-row>

        <b-col xl="4" sm="6">
          <b-media no-body>
            <b-media-aside class="mr-2">
              <b-avatar size="48"  variant="light-primary">
                <feather-icon size="24" icon="UsersIcon" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ data.countUser }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                Total utilisateurs
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>

        <b-col xl="4" sm="6">
          <b-media no-body>
            <b-media-aside class="mr-2">
              <b-avatar size="48"       variant="light-success">
                <feather-icon size="24" icon="CheckCircleIcon"/>
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ data.countByDisabledFalse }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                Utilisateurs actifs
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>

        <b-col xl="4" sm="6">
          <b-media no-body>
            <b-media-aside class="mr-2">
              <b-avatar size="48" variant="light-danger">
                <feather-icon size="24" icon="SlashIcon" />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ data.countByDisabledTrue }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                Utilisateurs désactivés
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>

      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody,
  BRow, BCol, BMedia, BMediaAside, BMediaBody, BAvatar,
} from 'bootstrap-vue'

export default {
  components: {
    BCard, BCardHeader, BCardTitle, BCardText, BCardBody,
    BRow, BCol, BMedia, BMediaAside, BMediaBody, BAvatar
  },

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
